import "core-js/stable";
import { ConnectedMain } from "fleet/controller/connected-main";
import {
  appReducers,
  appSagas,
  pageReducers,
  pageSagas,
} from "fleet/redux-store";
import { withTracker } from "integrations/google-analytics";
import * as Sentry from "integrations/sentry";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Route, BrowserRouter } from "react-router-dom";
import { buildApplicationStore } from "redux-store";
import "regenerator-runtime/runtime";
import Highcharts from "ui/highcharts";
import { configureAxiosLoader } from "util/xhr";

import "../../style/index.less";

Sentry.init();

const storeConfig = {
  appReducers,
  appSagas,
  pageReducers,
  pageSagas,
  debug: true,
};
const store = buildApplicationStore(storeConfig);

configureAxiosLoader(store);

function initFleet() {
  Highcharts.configure();

  return render(
    <Provider store={store}>
      <BrowserRouter>
        <Route path="/" component={withTracker(ConnectedMain)} />
      </BrowserRouter>
    </Provider>,
    document.getElementById("cortex-fleet"),
  );
}

export default initFleet();
export { initFleet };
